<script setup>
  import { ref } from "vue";
  const iframeSource = ref("https://lottie.host/embed/d5036a7c-3ad7-4fc3-a635-a7bc19b51fd4/oChMzblBPL.json");
</script>

<template>
  <div>
    <iframe class="w-100 h-100" :src="iframeSource"></iframe>
  </div>
</template>
